import { DefaultDirections, SortProviderProps, UrlSortProvider } from '@tableau/data-catalog-shared';
import * as React from 'react';

import { VirtualConnectionTableOrderField, OrderDirection } from '../../../../gen-src/queries/globalTypes';

export type VirtualConnectionTablesValidSortFields =
  VirtualConnectionTableOrderField.NAME |
  VirtualConnectionTableOrderField.DOWNSTREAM_DATASOURCES_COUNT |
  VirtualConnectionTableOrderField.DOWNSTREAM_WORKBOOKS_COUNT |
  VirtualConnectionTableOrderField.IS_CERTIFIED;


export const VirtualConnectionTablesDefaultDirections: DefaultDirections<VirtualConnectionTablesValidSortFields> = {
  [VirtualConnectionTableOrderField.NAME]: OrderDirection.ASC,
  [VirtualConnectionTableOrderField.DOWNSTREAM_DATASOURCES_COUNT]: OrderDirection.DESC,
  [VirtualConnectionTableOrderField.DOWNSTREAM_WORKBOOKS_COUNT]: OrderDirection.DESC,
  [VirtualConnectionTableOrderField.IS_CERTIFIED]: OrderDirection.DESC, // Certified items at the top
};

export const VirtualConnectionTablesDefaultSortField = VirtualConnectionTableOrderField.DOWNSTREAM_WORKBOOKS_COUNT;

export function VirtualConnectionTablesGridSortProvider(
  props: Pick<SortProviderProps<VirtualConnectionTablesValidSortFields>, 'children'>
): JSX.Element {
  return (
    <UrlSortProvider<VirtualConnectionTablesValidSortFields>
      validOrderFieldsWithDefaultDirections={VirtualConnectionTablesDefaultDirections}
      defaultField={VirtualConnectionTablesDefaultSortField}
    >
      {props.children}
    </UrlSortProvider>
  );
}
